export const LOCALES = ["ru-RU", "ky-KG", "en-US"] as const;
export const DEFAULT_LOCALE = LOCALES[0];
